import { ClubGenre } from '@fable/types'
import { css } from '@fable/theme'
import { analytics } from 'analytics'
import { useHome } from 'app/marketing/context'
import { Carousel, CarouselController } from 'components/carousel'
import { SearchFilterButton } from './SearchFilterButton'
import { useSearchParams } from 'react-router-dom'
import { formatGenreParam } from '@fable/utils'
import { useCallback, useEffect, useState } from 'react'

export const SearchFilterList = ({
  list,
  controller,
}: {
  list: ClubGenre[]
  controller: CarouselController
}) => {
  const { activeFilter, setActiveFilter } = useHome()
  const [searchParams, setSearchParams] = useSearchParams()
  const [loaded, setLoaded] = useState(false)

  const getTestId = (id: string) => {
    const active = activeFilter === id ? '-active' : ''
    const testId = `clubs-filter-${id}`
    return `${testId}${active}`
  }

  const updateSearchParams = (genre: ClubGenre) => {
    if (genre.id === 'featured') {
      searchParams.delete('filter')
      setSearchParams(searchParams)
      return
    }

    const filter = formatGenreParam(genre.name)
    setSearchParams({ filter })
  }

  const scrollToDefaultIndex = useCallback(() => {
    if (!!controller?.instance && !loaded) {
      const genreIndex = list.findIndex((genre) => genre.id === activeFilter)
      const maxIdx = controller.instance.track.details.maxIdx
      let index = 0

      if (genreIndex > 0 && genreIndex < maxIdx) {
        index = genreIndex - 1
      } else if (genreIndex > maxIdx) {
        index = maxIdx
      }

      controller.instance.moveToIdx(index)
      setLoaded(true)
    }
  }, [activeFilter, controller, loaded, list])

  useEffect(() => scrollToDefaultIndex(), [scrollToDefaultIndex])

  return (
    <Carousel
      className={css`
        max-width: 100%;
        .keen-slider__slide {
          width: auto !important;
        }
      `}
      controller={controller}
      options={{
        rubberband: false,
        slides: { perView: 'auto', spacing: 8 },
      }}
      childWidths={[{ width: 'auto', breakpoint: 'base' }]}
      plugins={['wheel']}
      noOverflow
    >
      {list.map((genre, i) => (
        <SearchFilterButton
          key={i}
          dataTestId={getTestId(genre.id)}
          selected={activeFilter === genre.id}
          onClick={() => {
            setActiveFilter(genre.id)
            analytics.events.genreFilterEnabled({ genre: genre.name })
            updateSearchParams(genre)
          }}
        >
          {genre.name}
        </SearchFilterButton>
      ))}
    </Carousel>
  )
}
